export class ParcelLimitedQuantity {
  lqUnno: string
  lqPgGroup: string
  lqCCode: string
  lqClass: string
  lqSubWeight: string

  constructor(lqUnno: string, lqPgGroup: string, lqCCode: string, lqClass: string, lqSubWeight: string) {
    this.lqUnno = lqUnno
    this.lqPgGroup = lqPgGroup
    this.lqCCode = lqCCode
    this.lqClass = lqClass
    this.lqSubWeight = lqSubWeight
  }
}
